import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import ThemeWrapper from '@common/theme';
import { store } from './store';
import router from './routes';

function App() {
  return (
    <Provider store={store}>
      <ThemeWrapper>
        <RouterProvider router={router} />
      </ThemeWrapper>
    </Provider>
  );
}

export default App;
